import { BaseFeature, FeatureType } from '@core/shared/feature';
import { DefaultAbilityAction } from '@core/shared/ability';
export class MpfDocentsBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@mpf/docents/feature","featureId":"mpf-docents"},
      bundledItemModels: ["DocentItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users', 'mpf-courses'],
      abilityActions: [{
        action: DefaultAbilityAction.Manage,
        defaultBias: -1
      }],
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Dynamic,
        simpleAbilityCheck: 'Feature.mpf-docents.Manage',
        pluginClassName: 'MpfDocentsFrontendFeature'
      }, {
        forPlatform: 'frontend-management',
        type: FeatureType.Dynamic,
        simpleAbilityCheck: 'Feature.mpf-docents.Manage',
        pluginClassName: 'MpfDocentsFrontendManagementFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfDocentsFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfDocentsBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfDocentsBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {
          DocentItem: info => {
            return ['/docents', typeof info === 'number' ? info : info.id];
          }
        }
      }
    };
  }
}